// src/pages/Signup.js
import React, { useState } from "react";
import { registerUser, loginWithGoogle, loginWithFacebook } from "../services/authService";
import { useNavigate } from "react-router-dom";
import "../pages/signup.css";

const Signup = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSignup = async (e) => {
        e.preventDefault();
        try {
            await registerUser(email, password);
            navigate("/login");
        } catch (err) {
            setError("Signup failed. Try again.");
        }
    };

    const handleGoogleSignup = async () => {
        await loginWithGoogle();
        navigate("/");
    };


    return (
        <div className="signup-container">
            <div className="signup-box">
                <h2>Create Your Account</h2>

                {error && <p className="error">{error}</p>}

                {/* Social Signup Buttons */}
                <button className="google-btn" onClick={handleGoogleSignup}>Sign up with Google</button>


                {/* Traditional Signup Form */}
                <form onSubmit={handleSignup}>
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <button type="submit">Sign Up</button>
                </form>

                <p className="login-link">Already have an account? <a href="/login">Login</a></p>
            </div>
        </div>
    );
};

export default Signup;
